// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    all: unset;

    display: inline-block;
    border-radius: 5px;
    padding: 5px 15px;
    margin: 5px;
    cursor: pointer;
}
.button svg {
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -0.2em;
    margin-right: 5px;
}


.button:hover {
    filter: opacity(80%);
}
button.button:disabled {
    filter: opacity(50%);
}


.button.default {
    background-color: var(--primary-color-light);
    border: none;
    color: var(--primary-color-dark);
}
.button.default:hover{
    filter: brightness(95%);
}
.button.primary {
    background-color: var(--primary-color-main);
    border: thin solid var(--primary-color-main);
    color: white;
}
.button.success {
    background-color: var(--success-color-main);
    border: thin solid var(--success-color-main);
    color: white;
}
.button.warn {
    background-color: var(--danger-color-main);
    border: thin solid var(--danger-color-main);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./client/components/generic/button/Button.css"],"names":[],"mappings":"AAAA;IACI,UAAU;;IAEV,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,iBAAiB;AACrB;;;AAGA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;;;AAGA;IACI,4CAA4C;IAC5C,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,2CAA2C;IAC3C,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,2CAA2C;IAC3C,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,0CAA0C;IAC1C,2CAA2C;IAC3C,YAAY;AAChB","sourcesContent":[".button {\n    all: unset;\n\n    display: inline-block;\n    border-radius: 5px;\n    padding: 5px 15px;\n    margin: 5px;\n    cursor: pointer;\n}\n.button svg {\n    width: 1.2em;\n    height: 1.2em;\n    margin-bottom: -0.2em;\n    margin-right: 5px;\n}\n\n\n.button:hover {\n    filter: opacity(80%);\n}\nbutton.button:disabled {\n    filter: opacity(50%);\n}\n\n\n.button.default {\n    background-color: var(--primary-color-light);\n    border: none;\n    color: var(--primary-color-dark);\n}\n.button.default:hover{\n    filter: brightness(95%);\n}\n.button.primary {\n    background-color: var(--primary-color-main);\n    border: thin solid var(--primary-color-main);\n    color: white;\n}\n.button.success {\n    background-color: var(--success-color-main);\n    border: thin solid var(--success-color-main);\n    color: white;\n}\n.button.warn {\n    background-color: var(--danger-color-main);\n    border: thin solid var(--danger-color-main);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
